import { Injectable } from "@angular/core";
import { Functions, httpsCallable } from "@angular/fire/functions";

export interface AskFlaggerDocChunk {
	uid?: string;
	header?: string;
	category?: string;
	content?: string;
	pageUid?: string;
	tags?: string[];
	similarity?: number;
}

export interface AskFlaggerAnswer {
	answer: string;
	chunks: AskFlaggerDocChunk[];
	pageUid?: string;
	source?: string;
}

export interface AskFlaggerSuggestedQuestion {
	label: string;
	question: string;
}

export interface AskFlaggerContextOptions {
	contextTitle?: string;
	intro?: string;
	placeholder?: string;
	suggestedQuestions?: AskFlaggerSuggestedQuestion[];
	initialQuestion?: string;
	autoAskInitialQuestion?: boolean;
}

export interface AskFlaggerSeedResult {
	pageUid: string;
	source: string;
	app: string;
	tenantId?: string;
	removed: number;
	count: number;
}

const ASK_FLAGGER_FUNCTIONS = {
	seedChunks: "seedFlaggerDocumentationChunks",
	searchDocs: "searchFlaggerDocsByEmbedding",
	answerQuestion: "answerQuestionWithFlaggerDocs",
};

@Injectable({
	providedIn: "root",
})
export class AskFlaggerService {
	constructor(private fns: Functions) {}

	async seedFlaggerDocumentationChunks() {
		const callable = httpsCallable(this.fns, ASK_FLAGGER_FUNCTIONS.seedChunks);
		const result = await callable({});
		return result.data as AskFlaggerSeedResult;
	}

	async searchFlaggerDocsByEmbedding(query: string, topK: number = 6) {
		const callable = httpsCallable(this.fns, ASK_FLAGGER_FUNCTIONS.searchDocs);
		const result = await callable({ query, topK });
		return result.data as { chunks: AskFlaggerDocChunk[] };
	}

	async answerQuestionWithFlaggerDocs(question: string, topK: number = 6) {
		// TODO Ask Flagger v2: route through a bot message channel and Firestore trigger.
		const callable = httpsCallable(this.fns, ASK_FLAGGER_FUNCTIONS.answerQuestion);
		const result = await callable({ question, topK });
		return result.data as AskFlaggerAnswer;
	}
}
